module.exports = __webpack_public_path__ + "static/media/payment-link-bg.bac49343.svg";